import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PackagesSection } from './components/PackagesSection';
import { FeaturesSection } from './components/FeaturesSection';
import { GallerySection } from './components/GallerySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { SoftPlayPackages } from './pages/SoftPlayPackages';
import { LuxurySoftPlayPackages } from './pages/LuxurySoftPlayPackages';
import { BounceHousePackages } from './pages/BounceHousePackages';
import { PhotoBoothPage } from './pages/PhotoBoothPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { FAQPage } from './pages/FAQPage';
import { KidsBenefitsSection } from './components/KidsBenefitsSection';
// ScrollToTop component to handle automatic scrolling
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // If there's a hash in the URL (like #faq), don't scroll to top
    if (hash) return;
    // Otherwise, scroll to top
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
export function App() {
  // Set the document title once when the app loads
  useEffect(() => {
    document.title = 'Toddler Time Soft Play Rentals & More';
  }, []);
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="font-sans text-gray-800" data-id="element-2">
        <Header data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/softplay" element={<SoftPlayPackages data-id="element-6" />} data-id="element-5" />
          <Route path="/luxurysoftplay" element={<LuxurySoftPlayPackages data-id="element-8" />} data-id="element-7" />
          <Route path="/bouncehouse" element={<BounceHousePackages data-id="element-10" />} data-id="element-9" />
          <Route path="/photobooth" element={<PhotoBoothPage data-id="element-12" />} data-id="element-11" />
          <Route path="/contact" element={<ContactPage data-id="element-14" />} data-id="element-13" />
          <Route path="/about" element={<AboutPage data-id="element-16" />} data-id="element-15" />
          <Route path="/testimonials" element={<TestimonialsPage data-id="element-18" />} data-id="element-17" />
          <Route path="/faq" element={<FAQPage data-id="element-20" />} data-id="element-19" />
          <Route path="/" element={<main data-id="element-22">
                <HeroSection data-id="element-23" />
                <FeaturesSection data-id="element-24" />
                <PackagesSection data-id="element-25" />
                <KidsBenefitsSection data-id="element-26" />
                <GallerySection data-id="element-27" />
                <TestimonialsSection data-id="element-28" />
                <FAQSection data-id="element-29" />
                <ContactSection data-id="element-30" />
              </main>} data-id="element-21" />
        </Routes>
        <Footer data-id="element-31" />
      </div>
    </Router>;
}